import { mapEnumToOptions } from '@abp/ng.core';

export enum WarehouseType {
  UPM = 0,
  EPS = 1,
}

export const warehouseTypeOptions = mapEnumToOptions(WarehouseType);
